import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { Spinner } from '@/components/ui/spinner'
import { useDeleteDocumentTheme } from '@/services/queries/document_themes'

export const DeleteThemeButton = ({
  documentPageThemeId,
}: {
  documentPageThemeId: string
}) => {
  const { isPending, mutate: deleteDocumentTheme } = useDeleteDocumentTheme()
  return (
    <DropdownMenuItem
      className="cursor-pointer"
      onClick={() => deleteDocumentTheme(documentPageThemeId)}
    >
      {isPending ? (
        <>
          <Spinner /> Deleting
        </>
      ) : (
        <span>Delete</span>
      )}
    </DropdownMenuItem>
  )
}
